import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { toastShow } from "../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarYarn, getCalibres, getCross, getEfectos, getFibras, getLoster, getRecycled, getTypes, getTypesCotton, getTypesPoly, getYarn } from "../../../API/Desarrollo/DesarrolloRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import MaestrosCRUD from './MaestrosCRUD'
import YarnSynteticCRUD from "../CRUD/YarnSynteticCRUD";
import YarnCottonCRUD from "../CRUD/YarnCottonCRUD";
import YarnSpandexCRUD from "../CRUD/YarnSpandexCRUD";

const MestrosScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [showDialog, setShowDialog] = useState(false);
  const [dialogYarnS, setDialogYarnS] = useState(false);
  const [dialogYarnC, setDialogYarnC] = useState(false);
  const [dialogSpandex, setDialogSpandex] = useState(false);
  const [IdCrud, setIdCrud] = useState(null);

  const [selected, setSelected] = useState(null)
  


  const getInfo = async () => {
    setLoading(true);

    let result;
    switch (activeIndex) {
      case 0:
        result = await getYarn();
        break;
      case 1:
        result = await getCalibres();
        break;
      case 2:
        result = await getTypes();
        break;
      case 3:
        result = await getEfectos();
        break;
      case 4:
        result = await getFibras()
        break;
      case 5:
        result = await getTypesCotton();
        break;
      case 6:
        result = await getLoster();
        break;
      case 7:
        result = await getRecycled();
        break;
      case 8:
        result = await getCross();
        break;
      case 9:
        result = await getTypesPoly();
        break;
      default:
        console.warn('Invalid activeIndex');
        setLoading(false);
        return;
    }

    setData(result);
    setLoading(false);
  };

  const openDialog = () => {
    switch (activeIndex) {
      case 0:
        setIdCrud(1)
        setShowDialog(true);
        break;
      case 1:
        setIdCrud(1)
        setShowDialog(true);
        break;
      case 2:
        setIdCrud(2)
        setShowDialog(true);
        break;
      case 3:
        setIdCrud(3)
        setShowDialog(true);
        break;
      case 4:
        setIdCrud(4)
        setShowDialog(true)
        break;
      case 5:
        setIdCrud(5)
        setShowDialog(true);
        break;
      case 6:
        setIdCrud(6)
        setShowDialog(true);
        break;
      case 7:
        setIdCrud(7)
        setShowDialog(true);
        break;
      case 8:
        setIdCrud(8)
        setShowDialog(true);
        break;
      case 9:
        setIdCrud(9)
        setShowDialog(true);
        break;
      default:
        console.warn('Invalid index for dialog');
        break;
    }
  };

  //----COLUMNAS----  
  const columsYarn = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdYarnTitle',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Correlativo',
      headerEn: 'Correlativo',
      frozen: true,
      field: 'Correlativo',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'small',
      Format: 'Modal'
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'StyleCategory',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Hilo',
      headerEn: 'Yarn',
      field: 'Yarn',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'large',
      flex: 1,
      minWidth:500,
    },
    {
      header: 'Calibre',
      headerEn: 'Calibre',
      field: 'Calibre',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Filamentos',
      headerEn: 'Filament',
      field: 'Filamentos',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Tipo',
      headerEn: 'Type',
      field: 'Type',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Ply',
      headerEn: 'Ply',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      field: 'Play',
      className: 'Xsmall',
    },
    {
      header: 'CrossSection',
      headerEn: 'CrossSection',
      field: 'CrossSection',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Heat',
      headerEn: 'Heat',
      field: 'Heat',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Loster',
      headerEn: 'Loster',
      field: 'Loster',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Recycled',
      headerEn: 'Recycled',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      field: 'Recycled',
      className: 'small',
    },
    {
      header: 'Efecto',
      headerEn: 'Efecto',
      field: 'Efecto',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Tipo Tejido',
      headerEn: 'Tipo Tejido',
      field: 'TipoTejido',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'small',
    },
    {
      header: 'Origen',
      headerEn: 'Origin',
      field: 'Origin',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        if(data?.Spandex){
          setDialogSpandex(true)
          return
        }
        if(data?.IdStyleCategory === 1){
          setDialogYarnC(true)
        }else if (data?.IdStyleCategory ===2){
          setDialogYarnS(true)
        }
      },
      className: 'Xsmall',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdYarnTitle",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdYarnTitle){
              setSelected(rowData)
              if(rowData?.Spandex){
                setDialogSpandex(true)
                return
              }
              if(rowData?.IdStyleCategory === 1){
                setDialogYarnC(true)
              }else if(rowData?.IdStyleCategory === 2){
                setDialogYarnS(true)
              }
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
        {
          icon: "pi pi-trash",
          tooltip: "Eliminar",
          onClick: (rowData) => {
            if(rowData?.IdYarnTitle){
              EliminarYarm(rowData)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]
  
  const columsCalibres = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdCalibre',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      Format: "DateTime",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setIdCrud(1)
        setSelected(data);
      },
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setIdCrud(1)
        setSelected(data);
      },
      Sumary: 'count',
    },
    {
        header: 'Categoría',
        headerEn: 'Category',
        field: 'StyleCategory',
        className: 'large',
        onCellDoubleClicked: ({ data }) => {
          setIdCrud(1)
          setShowDialog(true)
          setSelected(data);        
        },
    },
    {
        header: 'Calibre',
        headerEn: 'Caliber',
        field: 'CalibreInt',
        className: 'large',
        onCellDoubleClicked: ({ data }) => {
            setIdCrud(1)
            setShowDialog(true)
            setSelected(data);
        },
    },
    {
      header: 'Descripción',
      headerEn: 'Descripction',
      field: 'Description',
      className: 'large',
      flex: 1,
      minWidth: 200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdKnitCost",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdCalibre){
                setIdCrud(1)
                setShowDialog(true)
                setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ]

  const columsTypes = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdType',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(2)
        setShowDialog(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      Sumary: 'count',
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(2)
        setShowDialog(true)
        setSelected(data);
      },
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: ' Categoría',
      headerEn: 'Category',
      field: 'StyleCategory',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(2)
        setShowDialog(true)
        setSelected(data);
      },
    },
    {
      header: 'Spinning',
      headerEn: 'Spinning',
      field: 'Type',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(2)
        setShowDialog(true)
        setSelected(data);
      },
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(2)
        setShowDialog(true)
        setSelected(data);
      },
      className: 'large',
      flex: 1,
      minWidth: 200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'small',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdType",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdType){
                setIdCrud(2)
                setShowDialog(true)
                setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ]

  const columsEfectos = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdEfecto',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(3)
        setShowDialog(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(3)
        setShowDialog(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(3)
        setShowDialog(true)
        setSelected(data);        
      },
    },
    {
      header: 'Efecto',
      headerEn: 'Effect',
      field: 'Efecto',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
          setIdCrud(3)
          setShowDialog(true)
          setSelected(data);
      },
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(3)
        setShowDialog(true)
        setSelected(data);
      },
      flex:1,
      minWidth: 200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdEfecto",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdEfecto){
                setIdCrud(3)
                setShowDialog(true)
                setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]
  
  const columsFibras = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdFibra',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(4)
        setSelected(data)
        setShowDialog(true) 
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(4)
        setSelected(data)
        setShowDialog(true) 
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(4)
        setShowDialog(true)
        setSelected(data);        
      },
    },
    {
      header: 'Fibra',
      headerEn: 'Fiber',
      field: 'Fiber',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(4)
        setSelected(data)
        setShowDialog(true) 
      },
      className: 'large',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(4)
        setSelected(data)
        setShowDialog(true) 
      },
      flex: 1,
      minWidth: 200,
      field: 'Description',
      className: 'small',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdFibra",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdFibra){
                setIdCrud(4)
                setSelected(rowData)
                setShowDialog(true) 
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsTypesCotton = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdTypeCotton',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(5)
        setSelected(data);
        setShowDialog(true)
      },
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(5)
        setSelected(data);
        setShowDialog(true)
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(5)
        setShowDialog(true)
        setSelected(data);        
      },
    },
    {
      header: 'Tipo',
      headerEn: 'Type',
      field: 'TypeCotton',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(5)
        setSelected(data);
        setShowDialog(true)
      },
      className: 'large',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(5)
        setShowDialog(true)
        setSelected(data);
      },
      className: 'large',
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdTypeCotton",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdTypeCotton){
                setIdCrud(5)
                setShowDialog(true)
                setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsLoster = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdLoster',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(6)
        setShowDialog(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      frozen: true,
      headerEn: "Status",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(6)
        setShowDialog(true)
        setSelected(data);
      },
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Luster',
      headerEn: 'Luster',
      field: 'Loster',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(6)
        setShowDialog(true)
        setSelected(data);
      },
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'Xlarge',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(6)
        setShowDialog(true)
        setSelected(data);
      },
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdDyeType",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdLoster){
                setIdCrud(6)
                setShowDialog(true)
                setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsRecycled = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdRecycle',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(7)
        setShowDialog(true)
        setSelected(data);
      },
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      Sumary: 'count',
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(7)
        setShowDialog(true)
        setSelected(data);
      },
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
        header: 'Categoría',
        headerEn: 'Category',
        field: 'StyleCategory',
        className: 'large',
        onCellDoubleClicked: ({ data }) => {
            setIdCrud(7)
            setShowDialog(true)
          setSelected(data);
        },
    },
    {
      header: 'Reciclado',
      headerEn: 'Recycled',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(7)
        setShowDialog(true)
        setSelected(data);
      },
      field: 'Recycled',
      className: 'large',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(7)
        setShowDialog(true)
        setSelected(data);
      },
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdRecycle",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdRecycle){
                setIdCrud(7)
                setSelected(rowData)
                setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsCross = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdCross',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(8)
        setShowDialog(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(8)
        setShowDialog(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
        header: 'Cross',
        headerEn: 'Cross',
        field: 'CrossSection',
        className: 'large',
        onCellDoubleClicked: ({ data }) => {
            setIdCrud(8)
            setShowDialog(true)
          setSelected(data);
        },
      },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(8)
        setShowDialog(true)
        setSelected(data);
      },
      flex:1,
      minWidth: 200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdCross",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdCross){
                setIdCrud(8)
                setSelected(rowData)
                setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsTypesPoly = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdTypePoly',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(9)
        setSelected(data);
        setShowDialog(true)
      },
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(9)
        setSelected(data);
        setShowDialog(true)
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Tipo',
      headerEn: 'Type',
      field: 'TypePoly',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(9)
        setSelected(data);
        setShowDialog(true)
      },
      className: 'large',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setIdCrud(9)
        setShowDialog(true)
        setSelected(data);
      },
      className: 'large',
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdTypePoly",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdTypePoly){
              setIdCrud(9)
              setShowDialog(true)
              setSelected(rowData)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  //----TABLAS-----

  const tableYarnTitle = {
    Columns: columsYarn,
    Data: data,
    showModal: () => {}
  }

  const tableCalibre = {
    Columns: columsCalibres,
    Data: data,
  }

  const tableTypes = {
    Columns: columsTypes,
    Data: data,
  }

  const tableEfectos = {
    Columns: columsEfectos,
    Data: data,
  }

  const tableFibras = {
    Columns: columsFibras,
    Data: data,
    showModal: () => {}
  }

  const tableTypesC = {
    Columns: columsTypesCotton,
    Data: data,
  }

  const tableLoster = {
    Columns: columsLoster,
    Data: data,
  }
  
  const tableRecycled = {
    Columns: columsRecycled,
    Data: data,
  }
  
  const tableCross = {
    Columns: columsCross,
    Data: data,
  }

  const tableTypesS = {
    Columns: columsTypesPoly,
    Data: data,
  }

  const items = [
    {
      label: "Cotton",
      command: () => {
        setDialogYarnC(true)
      }
    },
    {
      label: "Synthetic",
      command: () => {
        setDialogYarnS(true)
      }
    },
    {
      label: "Spandex",
      command: () => {
        setDialogSpandex(true)
      }
    },
  ];
  
  const EliminarYarm = (Data) => {
    confirmDialog({
      message: "Esta seguro que desea eliminar",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: async () => {
        const resp = await EliminarYarn(Data)

        setLoading(true)
        if(resp[0]?.ESTADO === 1){
          toastShow(toast, "success", "Eliminado", "Hilo eliminado correctamente.");
          setTimeout(() => {
            setLoading(false)
            getInfo()
          }, 700);
        }else{
          toastShow(toast, "error", "Error", "Error all eliminar Hilo.");
        }
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  }
  

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Maestros", config.language));
  }, [activeIndex]);
  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "Maestros", config.language)}</h2>
            <ConfirmDialog />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />


            {activeIndex !== 0 && (
              <Button
                icon="pi pi-plus"
                tooltip="Nuevo"
                onClick={(e) => openDialog()}
              />
            )}

            {activeIndex === 0 && (
              <SplitButton
                label=""
                icon="pi pi-plus"
                tooltip="Agregar"
                tooltipOptions={{ className: "purple-tooltip", position: "top" }}
                onClick={(e) => {}}
                model={items}
              />
            )}

          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "yarnTitle", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableYarnTitle} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Calibres", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableCalibre} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Spinning", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableTypes} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Efectos", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableEfectos} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Fibras", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableFibras} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Types Cotton", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableTypesC} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Luster", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableLoster} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Recycled", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableRecycled} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Cross", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableCross} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Types Poly", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableTypesS} />
                </div>
              </TabPanel>

            </TabView>
          </div>
        }
      />

      {showDialog && (
        <MaestrosCRUD
          dialog={showDialog}
          setDialog={setShowDialog}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
          IdCrud={IdCrud}
        />
      )}

      {dialogYarnS && (
        <YarnSynteticCRUD
          dialog={dialogYarnS}
          setDialog={setDialogYarnS}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogYarnC && (
        <YarnCottonCRUD
          dialog={dialogYarnC}
          setDialog={setDialogYarnC}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}


      {dialogSpandex && (
        <YarnSpandexCRUD
          dialog={dialogSpandex}
          setDialog={setDialogSpandex}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

    </div>
  );
};

export default MestrosScreen;
